import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useLocales } from "expo-localization";

type LocationResponse = {
	country_code: string;
	country_name: string;
	city?: string;
	region?: string;
};

const fetchLocation = async (): Promise<LocationResponse> => {
	const response = await axios.get<LocationResponse>("https://ipapi.co/json/");
	return response.data;
};

export const useLocation = () => {
	const locales = useLocales();
	const regionCode = locales?.length ? locales[0].regionCode : null;

	const { data, isLoading, error } = useQuery({
		queryKey: ["user-location"],
		queryFn: fetchLocation,
		staleTime: 1000 * 60 * 60 * 24,
		retry: 1,
	});

	const countryCode = data?.country_code || regionCode;

	return {
		countryCode,
		isLoading,
		error,
		countryName: data?.country_name,
		city: data?.city,
		region: data?.region,
	};
};
